// once we work on the functionality, the selectors will be created here
// sample code

import { createSelector } from 'reselect';
import { initState } from './reducer';

const deliveryInfoReducer = (state) => state.deliveryinfo || initState;

const deliveryInfoData = createSelector(deliveryInfoReducer, (cnter) => cnter.deliveryInfoData.cardDeliveryAddress);
const isdeliveryLoading = createSelector(deliveryInfoReducer, (cnter) => cnter.isdeliveryLoading);

export default {
	deliveryInfoData,
	isdeliveryLoading,
	deliveryInfoReducer,
};
